import { render, staticRenderFns } from "./panelCost.vue?vue&type=template&id=b51a0ace&lang=pug"
import script from "./panelCost.vue?vue&type=script&lang=js"
export * from "./panelCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports